// extracted by mini-css-extract-plugin
export default {"cls1":"KvRLWT9Zgv1NLw4I0Ipx","cls2":"H_wyaA4E20wjRFKDXWXd KvRLWT9Zgv1NLw4I0Ipx"};